"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function InformationsDeContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-secondary py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={ref} className={`grid gap-12 md:grid-cols-2 md:gap-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <div className="flex flex-col gap-6">
            <div>
              <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                Courriel
              </h3>
              <Link to="mailto:joker.studio@hotmail.com" className="text-2xl sm:text-3xl font-medium text-primary hover:text-primary-hover transition-colors duration-[var(--duration-fast)] ease-[var(--ease-smooth)]">
                joker.studio@hotmail.com
              </Link>
            </div>
            <div>
              <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                Adresse
              </h3>
              <p className="text-2xl sm:text-3xl font-medium text-foreground">
                Montréal, QC
              </p>
            </div>
          </div>

          {}
          <div className="flex items-start justify-start md:justify-end gap-3">
            <Link to="https://www.linkedin.com" newTab className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary text-foreground-primary hover:bg-accent transition-all duration-[150ms] ease-[var(--ease-out-back)] hover:scale-105 focus-ring" aria-label="LinkedIn">
              <Linkedin className="w-6 h-6" />
            </Link>
            <Link to="https://www.instagram.com/the.joker.studio/?hl=en" newTab className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary text-foreground-primary hover:bg-accent transition-all duration-[150ms] ease-[var(--ease-out-back)] hover:scale-105 focus-ring" aria-label="Instagram">
              <Instagram className="w-6 h-6" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}